import { render, staticRenderFns } from "./authorize.vue?vue&type=template&id=37625d9a&scoped=true"
import script from "./authorize.vue?vue&type=script&lang=js"
export * from "./authorize.vue?vue&type=script&lang=js"
import style0 from "./authorize.vue?vue&type=style&index=0&id=37625d9a&prod&lang=stylus&scoped=scoped"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37625d9a",
  null
  
)

export default component.exports